import type { EditTarget, LayoutBlock, MenuItemEditTarget } from '@web-studio/shared-schemas';
import { pickMediaUrl } from '../../lib/media';
import type { MenuColumn, MenuItem } from '../../lib/parseMenuColumns';

export function menuItemHasContent(item: MenuItem): boolean {
  return Boolean(item.name.trim() || item.price.trim() || item.description.trim());
}

export function isMenuItemActive(
  activeEditTarget: MenuItemEditTarget | null | undefined,
  columnIndex: number,
  itemIndex: number,
): boolean {
  return (
    activeEditTarget?.kind === 'menu-item' &&
    activeEditTarget.columnIndex === columnIndex &&
    activeEditTarget.itemIndex === itemIndex
  );
}

export function isMenuColumnActive(
  activeEditTarget: EditTarget | null | undefined,
  columnIndex: number,
): boolean {
  return activeEditTarget?.kind === 'menu-column' && activeEditTarget.columnIndex === columnIndex;
}

/** Category image: column JSON first, then `media.categoryImage{n}`. */
export function resolveColumnImageUrl(
  block: LayoutBlock,
  column: MenuColumn,
  columnIndex: number,
): string | undefined {
  const fromColumn = column.imageUrl?.trim();
  if (fromColumn) {
    return fromColumn;
  }
  return pickMediaUrl(block, `categoryImage${columnIndex}`);
}

/** Dish image: item JSON first, then `media.itemImage_{c}_{i}`. */
export function resolveItemImageUrl(
  block: LayoutBlock,
  item: MenuItem,
  columnIndex: number,
  itemIndex: number,
): string | undefined {
  const fromItem = item.imageUrl?.trim();
  if (fromItem) {
    return fromItem;
  }
  return pickMediaUrl(block, `itemImage_${columnIndex}_${itemIndex}`);
}
